export default "__VITE_ASSET__DTq8g1so__"